/**
 * A single line of text cut to a set width with an ellipsis, the full value on hover. For table
 * cells holding free-text names (organizations, groups) that can run to any length: a fixed width
 * keeps rows one line high and columns aligned, and the tooltip means nothing is lost.
 *
 * Width is in `ch`, so it tracks the font rather than a pixel guess. 24ch fits a typical company
 * name in full.
 */
export interface TruncatedTextProps {
  text: string;
  /** Maximum width in characters (`ch`). */
  maxCh?: number;
}

export function TruncatedText({ text, maxCh = 24 }: TruncatedTextProps) {
  return (
    <span title={text} className="block truncate" style={{ maxWidth: `${maxCh}ch` }}>
      {text}
    </span>
  );
}
